import axios from "axios";
import http from "../ http-common";
//import { API_BASE_URL as API_URL } from "../config";
import store  from "../store";

const getApibaseurl = () => {
  const state = store.getState();
  console.log("kjhgfdsadfgh uytfyguyi ",state.server?.API_BASE_URL );
  return state.server?.API_BASE_URL 
};

class AdminService {
  getAll(page, limit) {
    var API_BASE_URL = getApibaseurl() + "/admin";
    return http.get(API_BASE_URL + "/admins", {
      params: {
        page,
        limit,
      },
    });
  }

  get(id) {
    return http.get(`/admin/admins/${id}`);
  }

  create(data) {
    var API_BASE_URL = getApibaseurl() + "/admin";
    var formData = new FormData();
    formData.append("password", data.password);
    return axios.post(API_BASE_URL + "/admins", data);
  }

  update(id, form) {
    var formData = new FormData();
    for (const [key, value] of Object.entries(form)) {
      formData.append(`${key}`, `${value}`);
    }

    let config = {
      headers: {
        withCredentials: false,
        Authorization: "Bearer " + window.localStorage.token,
        // 'Access-Control-Allow-Origin': '*',
        // 'Accept': "*/*",
        // 'X-Requested-With': "XMLHttpRequest",
        // // 'Access-Control-Allow-Headers': '*',
        // 'Content-Type': 'application/json'
      },
    };

    return axios.post(`/admin/update/admin`, form, config);
  }

  delete(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.delete(`${API_BASE_URL}/admins/${id}`);
  }

  deleteAll() {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.delete(`${API_BASE_URL}/admins`);
  }
}

export default new AdminService();
